import React from 'react';
import metEmployedImg from '../Assets/maxresdefault.webp';
import Printer from '../Assets/3D-Printer.webp';
import unity from '../Assets/unityexploreworld.png';
import worldtreeSweeper from '../Assets/Screenshot_2024-04-04_190807.webp';
import dinoNFT from '../Assets/dinonft.png';
import { Link } from 'react-router-dom';
import './Cards.css';
import inclusee from '../Assets/original.jpeg'
import vireel from '../Assets/Vireel.png'
import landTempAnalyze from '../Assets/30-april-BLOG.jpg'

const Cards = () => {
    const cards = [
        { img: metEmployedImg, title: 'MetEmployed', subtitle: 'EduSands Hacks Winner', desc: 'Tackling social equity by providing the less fortunate with the same opportunities.', link: 'https://devpost.com/software/soluhacks' },
        { img: Printer, title: 'BioSafe3D', subtitle: 'Innovation Project', desc: 'Increasing 3D printer efficiency while making them more affordable and eco-friendly.', link: 'https://drive.google.com/drive/folders/1s56gmrxlXBasoJM-iDi_LU_zjG3toEDf?usp=sharing' },
        { img: unity, title: 'ExploreWorld', subtitle: 'Unity Game', desc: 'World exploration game with real-world physics and vehicle controls.', link: 'https://github.com/SurkhiSyed/Final-ExploreWorld' },
        { img: worldtreeSweeper, title: 'WorldTreeSweeper', subtitle: 'Unity RPG', desc: 'Solo-type RPG with challenging terrain and real-world physics principles.', link: 'https://github.com/SurkhiSyed/WorldTreeSweeper-Unity?tab=readme-ov-file' },
        { img: dinoNFT, title: 'DinoNFT', subtitle: 'HawkHacks 3rd Place', desc: 'Web3 dino game with blockchain wallet integration and token rewards.', link: 'https://github.com/SurkhiSyed/Hack' },
        { img: inclusee, title: 'Inclusee', subtitle: 'Adobe Express Addon', desc: 'Accessibility tool for designers to ensure creations are accessible to all.', link: 'https://devpost.com/software/inclusee' },
        { img: vireel, title: 'Vireel', subtitle: 'Startup', desc: 'News aggregation app delivering concise summaries tailored to user interests.', link: 'https://github.com/SurkhiSyed/Vireel' },
        { img: landTempAnalyze, title: 'Temp Analyzer', subtitle: 'C Program', desc: 'Analyzes land temperature data over 3 centuries using CSV files and GNU Plots.', link: 'https://github.com/SurkhiSyed/LandAverageTemperatures' },
    ];

  return (
    <div className='w-full py-8 px-4 bg-gradient-to-b from-transparent to-black/30'>
        <div className='max-w-7xl mx-auto'>
            <div className='text-center mb-8'>
                <h2 className='text-3xl md:text-4xl font-bold text-white mb-2'>
                    Featured <span className='text-[#00d59a]'>Projects</span>
                </h2>
                <p className='text-gray-400 text-sm md:text-base'>
                    Scroll horizontally to explore
                </p>
            </div>
            <div className='horizontal-scroll-container'>
                <div className='cards-grid'>
                    {cards.map((d, index) => (
                        <Link key={index} to={d.link} target='_blank' rel='noopener noreferrer' className='card-item'>
                            <div className='card-container-modern'>
                                <div className='card-image-container'>
                                    <img src={d.img} alt={d.title} className='card-image' />
                                    <div className='card-overlay'>
                                        <div className='overlay-content'>
                                            <p className='text-sm text-gray-300'>{d.desc}</p>
                                            <span className='view-project-btn'>View Project →</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-content'>
                                    <h3 className='card-title'>{d.title}</h3>
                                    <p className='card-subtitle'>{d.subtitle}</p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Cards;